
import { mapState } from "vuex";
import {
  configState,
  configGetters,
  configMutations,
  dashboardGetters,
  dashboardActions,
  dashboardMutations,
  usersMutations,
} from "~/store/helpers";
import createCardStep from "@/components/DashboardModals/createCardStep";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full";
export default {
  props: {
    modalKey: String,
    templateTypes: Array,
    createCardProcesses: Array,
    allTemplates: Array,
    aggregationTypes: Array,
    id: Number,
    active: Boolean,
  },
  data() {
    return {
      mId: this.$props.id,
      mTemplateTypes: [],
      numberImage: null,
      percentageImage: null,
      tableImage: null,
      mCreateCardProcesses: [],
      mAllTemplates: [],
      filteredTemplates: [],
      selectedProcess: null,
      isCreating: false,
      lastStep: null,
      disabledNextStep: true,
      payload: {},
      query: {
        name: "",
        description: "",
      },
      checked: "AND",
      selectedFilters: [],
      isAlert: false,
    };
  },
  watch: {
    checked(value) {
      this.SET_CURRENT_CARD({ condition: value });
    },
    allTemplates() {
      this.SET_CURRENT_CARD({});
      this.SET_CURRENT_CARD({ condition: this.checked });
      this.mTemplateTypes = this.$props.templateTypes;
      this.mCreateCardProcesses = this.$props.createCardProcesses;
      this.mAllTemplates = this.$props.allTemplates;
      this.isCreating = false;
      this.mTemplateTypes = this.mTemplateTypes.map((e) => ({
        ...e,
        count:
          e.key == "all" || !e.key
            ? this.mAllTemplates.length
            : this.mAllTemplates.filter(
                (item) => item.type == e.key || item.group == e.key
              ).length,
      }));
      this.selectedProcess = null;
      this.filteredTemplates = this.mAllTemplates;
      this.toggleItem("all");
    },
  },
  mounted() {
    this.numberImage = this.$i18n.locale === "en" ? "numberPreview" : "Sayi";
    this.tableImage = this.$i18n.locale === "en" ? "tablePreview" : "Tablo";
    this.percentageImage =
      this.$i18n.locale === "en" ? "percentagePreview" : "Yuzde";
    this.mTemplateTypes = this.$props.templateTypes;
    this.mCreateCardProcesses = this.$props.createCardProcesses;
    this.mAllTemplates = this.$props.allTemplates;
    this.isCreating = false;
    this.mTemplateTypes = this.mTemplateTypes.map((e) => ({
      ...e,
      count:
        e.key == "all" || !e.key
          ? this.mAllTemplates.length
          : this.mAllTemplates.filter(
              (item) => item.type == e.key || item.group == e.key
            ).length,
    }));
    this.selectedProcess = null;
    this.filteredTemplates = this.mAllTemplates;
    this.toggleItem("all");
  },
  computed: {
    ...configGetters,
    ...dashboardGetters,
    getCard() {
      return this.getCurrentCard();
    },
  },
  methods: {
    ...usersMutations,
    ...dashboardMutations,
    ...configMutations,
    ...dashboardActions,
    toggleItem(event) {
      if (event == "filtering") this.lastStep = "filtering";
      this.isCreating
        ? (this.mCreateCardProcesses = this.mCreateCardProcesses.map((e) => {
            return e.key == event
              ? { ...e, isSelected: true }
              : { ...e, isSelected: false };
          }))
        : (this.mTemplateTypes = this.mTemplateTypes.map((e) => {
            return e.key == event
              ? { ...e, isSelected: true }
              : { ...e, isSelected: false };
          }));
      this.selectedProcess = this.isCreating
        ? this.mCreateCardProcesses.find((e) => e.key == event).key
        : this.mTemplateTypes.find((e) => e.key == event).key;
      this.filteredTemplates =
        this.selectedProcess && this.selectedProcess != "all"
          ? this.mAllTemplates.filter(
              (e) =>
                e.type == this.selectedProcess ||
                e.group == this.selectedProcess
            )
          : this.mAllTemplates;
    },
    createCustomCard() {
      this.isCreating = true;
      this.toggleItem("filtering");
      this.lastStep = "filtering";
      this.disabledNextStep = false;
    },
    nextStep() {
      if (this.selectedFilters.some((e) => !e.value)) {
        this.isAlert = true;
        setTimeout(() => (this.isAlert = false), 4000);
        return;
      }
      this.isAlert = false;
      this.lastStep == "filtering"
        ? (this.toggleItem("selection"), (this.lastStep = "selection"))
        : (this.toggleItem("appearance"), (this.lastStep = "appearance"));
    },
    addedFields(event) {
      this.disabledNextStep = false;
    },
    removedFields(event) {
      if (event.length < 1) {
        this.disabledNextStep = true;
      }
    },
    tileForm(event) {},
    tileWidth(event) {},
    async save(event) {
      if (event.query) {
        let result = await this.$axios.get(
          `${localStorage.getItem("organizationId")}/advanced-queries/${
            event.id
          }/execute`
        );
        this.$router.push({
          name: "patients",
          params: { filter: "advanced-queries" },
        });
        this.SET_USERS(result.data);
        this.isCreating = false;
        this.toggleItem("all");
        this.$bvModal.hide(this.modalKey);
      } else if (event.target?.innerText == "Search") {
        let payload = this.getCard;
        delete payload.name;
        delete payload.description;
        let result = await this.$axios.post(
          `${localStorage.getItem("organizationId")}/advanced-queries/execute`,
          payload
        );
        this.$router.push({
          name: "patients",
          params: { filter: "advanced-queries" },
        });
        this.SET_USERS(result.data);
        this.isCreating = false;
        this.toggleItem("all");
        this.$bvModal.hide(this.modalKey);
      }
      let data = JSON.parse(JSON.stringify(this.getCard));
      let payload = this.isCreating
        ? { ...data, display_name: data.title }
        : event;
      this.isCreating = false;
      this.$bvModal.hide(this.modalKey);
      this.$emit("addedCard", payload);
      // let data = JSON.parse(JSON.stringify(this.getCard))
      // this.SET_NEW_CARDS({ board: this.$route.params.name, data: data })
    },
    async saveQuery(bvModalEvt) {
      bvModalEvt.preventDefault();
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.SET_CURRENT_CARD({
        name: this.query.name,
        description: this.query.description,
      });
      let result = await this.$axios.post(
        `${localStorage.getItem("organizationId")}/advanced-queries`,
        this.getCard
      );
      this.$bvModal.hide(this.modalKey);
      this.$bvModal.hide("saveQuery");
      this.save(result.data.data);
    },
    onHide(event) {
      if (!event) return;
      if (event.trigger == "backdrop") {
        this.SET_CURRENT_CARD({});
        this.isCreating = false;
        this.toggleItem("all");
        this.$emit("cancel");
      }
    },
    async deleteOption(event) {
      if (!event) return;
      await this.$axios.delete(
        `${localStorage.getItem("organizationId")}/advanced-queries/${event.id}`
      );
      this.$emit("update");
    },
  },
  components: {
    createCardStep,
    ValidationProvider,
    ValidationObserver,
  },
};
